import apiFetch from '@scale/frontend-lib/api-fetch';

export type TeamLeadInfoForWorkers = {
  workers: Record<string, string>;
  teamLeads: Record<string, { email: string; name: string; id: string }>;
};

export async function getTeamLeadInfoForWorkers(
  workerIds: string[],
): Promise<{ data: TeamLeadInfoForWorkers }> {
  return apiFetch(null, 'internal/expert-management/teamLeadInfoForWorkers', {
    method: 'POST',
    body: { workerIds },
  });
}
